import React from 'react';
import s from './select.module.css';
const SelectOptionEmpty = ({ emptyText = 'Ничего не найдено' }) => {
    return React.createElement("div", { className: s.emptyOption }, emptyText);
};
export default SelectOptionEmpty;
//# sourceMappingURL=option-empty.js.map